import { Injectable, isDevMode } from '@angular/core';
import { EMPTY } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { map } from 'rxjs/internal/operators/map';
import { UserService } from '../../user-service/user.service';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { AudiencedDaoService } from 'src/app/dao/audience-dao-service/audience-dao.service';
import { AudienceCapacity } from 'src/app/models/audience-models/audience-capacity.model';

@Injectable({
  providedIn: 'root'
})
export class AudienceCapacityService {

  accessToken = ['DEV', 'AUT'];

  constructor(
    private userService: UserService,
    private userStorageService: UserStorageService,
    private audienceDaoService: AudiencedDaoService
  ) { }

  public getCapacity(datetimeFrom, datetimeTo, centerInternalIdList) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.audienceDaoService.getCapacity(
        this.userStorageService.getContext(),
        this.userStorageService.getLang(),
        this.userStorageService.getUDID(),
        datetimeFrom,
        datetimeTo,
        centerInternalIdList
      ).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const audienceCapacity = new AudienceCapacity();
          Object.assign(audienceCapacity, o['data']['result']);
          return audienceCapacity;
        })
      );
    }
    return EMPTY;
  }

}
